module.exports = __webpack_public_path__ + "img/ide_logo.81f8c3fc.svg";